module.exports = __webpack_public_path__ + "static/media/basel-26.c4227651.jpg";